import { useEffect, useMemo, useState } from 'react';
import { DropdownOption } from 'uikit/inputs/dropdown/appDropdownInput';
import { useGetStudyNotesConfigQuery } from 'src/services/api/api-client/StudyNotesQuery';
import { useStudy } from 'src/helpers/hooks/useStudy';

export const useStudyNoteSelector = (options?: { enabled?: boolean }) => {
  const study = useStudy();
  const [selectedConfigId, setConfigId] = useState<number>();

  const formConfigQuery = useGetStudyNotesConfigQuery(
    { studyId: study!.id },
    { refetchOnMount: 'always', enabled: options?.enabled && !!study?.id },
  );

  useEffect(() => {
    if (!formConfigQuery.data) {
      setConfigId(undefined);
      return;
    }

    setConfigId(formConfigQuery.data.id);
  }, [formConfigQuery.data]);

  const configList = useMemo(
    () =>
      formConfigQuery.data
        ? [
            {
              key: formConfigQuery.data.id,
              text: formConfigQuery.data.title,
            } satisfies DropdownOption<number>,
          ]
        : [],
    [formConfigQuery.data],
  );

  const selectedConfig = useMemo(
    () => (selectedConfigId ? formConfigQuery.data : undefined),
    [formConfigQuery.data, selectedConfigId],
  );

  const selectorProps = {
    options: configList,
    value: configList.find((x) => x.key === selectedConfigId),
    onChange: (o: any) => setConfigId(o ? o.key : undefined),
    isRequired: !!formConfigQuery.data,
  };

  return { setConfigId, formConfigQuery, selectedConfig, selectorProps };
};
